export const notificationTypes = {
  PARTICIPATION_ASSIGNEE_ASSIGNED: 'participation-assignee_assigned',
  PARTICIPATION_ASSIGNEEE_UNASSIGNED: 'participation-assignee_unassigned',
  PARTICIPATION_OWNER_CHANGED: 'participation-owner_changed',
  PARTICIPATION_OWNER_ASSIGNED: 'participation-owner_assigned',
  PARTICIPATION_OWNER_UNASSIGNED: 'participation-owner_unassigned',
  VEHICLE_NEXT_SERVICE_NOTICE: 'vehicle-next_service_notice',
  VEHICLE_INSPECTION_EXPIRATION_NOTICE: 'vehicle-inspection_expiration_notice',
  VEHICLE_FILE_OPREATION_FINISHED: 'vehicle-file_operation_finished',
  VEHICLE_BACKGROUND_REMOVAL_FINISHED: 'vehicle_photo-remove_background_finished',
  SALE_VEHICLE_BACKGROUND_REMOVAL_FINISHED: 'sale_vehicle_photo-remove_background_finished',
  VEHICLE_PHOTO_ROTATE_FINISHED: 'vehicle_photo-rotate_finished',
  VEHICLE_PHOTO_COPY_FINISHED: 'vehicle_photo-copy_finished',
  SALE_VEHICLE_PHOTO_ROTATE_FINISHED: 'sale_vehicle_photo-rotate_finished',
  SALE_VEHICLE_PHOTO_COPY_FINISHED: 'sale_vehicle_photo-copy_finished',
  BATCH_DOWNLOAD_STATE_CHANGED: 'batch_download-bulk_event_state_changed',
  BULK_OPERATION_STATE_CHANGED: 'bulk_operation-state_changed',
  BULK_OPERATION_RECORDS_CHANGED: 'bulk_operation-records_changed',
  BULK_OPERATION_PROGRESS_CHANGED: 'bulk_operation-progress_changed',
  COMMENT_MENTION: 'comment-mention',
  COMMENT_RECORD_OWNER: 'comment-record_owner',
  SALE_VEHICLE_RESERVATION_CANCELLED: 'sale_vehicle-reservation_cancelled',
  PERMISSION_CHANGED: 'access_control-user_permission_changed',
  COMMUNICATION_UNREAD_CHANGED: 'communication-unread_changed',
  DATAGRID_CUSTOM_PRESET_SHARED: 'datagrid-custom_preset_shared',
  FILE_STORAGE_FILE_UPLOADED: 'file_storage-file_uploaded',
  FILE_STORAGE_FILE_VARIANT_UPLOADED: 'file_storage-file_variant_uploaded',
  VEHICLE_WARRANTY_EXPIRATION_NOTICE: 'vehicle-warranty_expiration_notice',
  VEHICLE_DAYS_SINCE_LAST_REPRICE_NOTICE: 'vehicle-days_since_last_reprice_notice',
  VEHICLE_UNREGISTERED_NOTICE: 'vehicle-unregistered_notice',
  ADVERTISEMENT_PUBLISHING_FAILED: 'advertisement-publishing_failed',
  SOURCING_FILTER_PRESET_UPDATE: 'sourcing-filter_preset_update',
  DATAGRID_EXPORT: 'datagrid-data_export',
  CUSTOM_CATALOGUE_REMAP_FINISHED: 'custom_catalogue-remap_finished',
  DIGITAL_DOCUMENT_SIGNED: 'digital_signature-document_signed',
  TASK_CREATED: 'task_management-task_created',
  TASK_UPDATED: 'task_management-task_updated',
  TASK_DUE_DATE_NOTICE: 'task_management-due_date_notice',
  TASK_COMMENTED: 'task_management-task_commented',
  TASK_REPORTER_CHANGED: 'task_management-task_reporter_changed',
  CUSTOM_FIELDS_NOTICE: 'custom_fields-expiration_notice',
  VEHICLE_INSPECTION_CLONED: 'vehicle-inspection_cloned',
  IMPORT_FINISHED: 'import-finished',
  BUSINESS_CASE_QUICK_UNREAD_MESSAGE: 'business_case-quick_unread_message',
  BUSINESS_CASE_UNREAD_MESSAGE: 'business_case-unread_message',
  BUSINESS_CASE_ONLINE_OFFER_ENGAGEMENT_CHANGED: 'business_case-online_offer_engagement_changed',
  CUSTOMER_MESSAGE_NEW_MESSAGE: 'customer_message-new_message',
  CUSTOMER_MESSAGE_UNREAD_MESSAGE: 'customer_message-unread_message',
  VEHICLE_INSPECTION_TO_REVISION: 'vehicle-inspection_to_review',
  VEHICLE_INSPECTION_RETURNED_TO_COMPLETION: 'vehicle-inspection_returned_for_completion',
  VEHICLE_INSPECTION_FINISHED: 'vehicle-inspection_finished',
  INTEGRATED_SERVICE_CHANGE: 'integrated_service-change_announced',
  INTEGRATED_SERVICE_EXTERNAL_PLANNER_CONFLICT: 'integrated_service-external_planner_conflict',
  PROMPT_BRIDGE_STATUS_CHANGED: 'prompt_bridge-status_changed',
  OFFER_VALIDITY_EXPIRATION: 'offer-validity_expiration',
  MAGIC_PUBLISHING_FINISHED: 'magic_publishing-finished',
  SALE_VEHICLE_PHOTO_CHECKER_REPORT_PROCESSING: 'sale_vehicle_photo_checker-report_processing',
  SALE_VEHICLE_PHOTO_CHECKER_REPORT_FAILED: 'sale_vehicle_photo_checker-report_failed',
  SALE_VEHICLE_PHOTO_CHECKER_REPORT_LOW_SCORE: 'sale_vehicle_photo_checker-report_low_score',
  CAR_PASS_READY: 'car_pass-ready',
  CAR_PASS_EXPIRED: 'car_pass-expired',
  CAR_PASS_FAILED: 'car_pass-failed',
  CAR_PASS_ACTION_REQUIRED: 'car_pass-action_required',
  INTEREST_VEHICLE_MATCH: 'interest-vehicle_match',
  RENTAL_VEHICLE_MILEAGE_LIMIT_NOTICE: 'rental_vehicle-mileage_limit_notice',
  RENTAL_VEHICLE_AVAILABILITY_EXPIRATION_NOTICE: 'rental_vehicle-availability_expiration_notice',
  ACCOUNTING_SUBJECT_CHANGED: 'accounting_subject-changed',
  USER_ABSENCE_DELEGATE_SELECTED: 'user_absence-delegate_selected',
  USER_ABSENCE_DELEGATION_STARTED: 'user_absence-delegation_started',
  USER_ABSENCE_DELEGATION_ENDED: 'user_absence-delegation_ended',
  BUSINESS_CASE_SELLING_INVOICE_PAID: 'business_case-selling_invoice_paid',
  BUSINESS_CASE_BUYING_INVOICE_PAID: 'business_case-buying_invoice_paid',
  FINANCING_ENDING_SENDING_FINISHED: 'sales-financing_ending_sending_finished',
  FINANCING_ENDING_REMINDER: 'sales-financing_ending_reminder',
  ORCHESTRATION_RULE_TRIGGERED: 'orchestration-rule_triggered',
  ORCHESTRATION_RULE_RAN_FOR_RECORD: 'orchestration-rule_ran_for_record',
  ORCHESTRATION_RULE_RAN_FOR_TEAM: 'orchestration-rule_ran_for_team',
  ORCHESTRATION_RULE_NOTIFIED_YOU: 'orchestration-rule_notified_you',
  ORCHESTRATION_RUN_AWAITING_CONFIRMATION: 'orchestration-run_awaiting_confirmation',
  ORCHESTRATION_RUN_STOPPED: 'orchestration-run_stopped',
  ORCHESTRATION_RULE_APPROVAL_REQUESTED: 'orchestration-rule_approval_requested',
  BUSINESS_CASE_CUSTOMER_RATING_RECEIVED: 'business_case-customer_rating_received',
  EMAIL_CREDENTIALS_SMTP_TEST_STATE_CHANGED: 'email_credentials-smtp_test_state_changed',
  NEW_VEHICLE_FACTORY_CONFIRMATION: 'new_vehicle-factory_confirmation',
  NEW_VEHICLE_FACTORY_VIN_CONFLICT: 'new_vehicle-factory_vin_conflict',
} as const;
